import styled from 'styled-components';
import {
  centerEssentials,
  flexColumn,
  flexRow
} from '../../../style/Global';
import Modal from '@material-ui/core/Modal';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


export const ModalTest = styled(Modal)`
    
    display: flex;
    justify-content: center;
    align-items: center;
`

export const ModalCard = styled(Card)`
  border-radius:10px;
  // height:50%;
  // width:50%;
`

export const ModalCardContent = styled(CardContent)`
  ${flexColumn}
  height:100%;
`

export const ModalBody = styled.div`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    height:100%;
    justify-content: center;
    margin-top: 20px;
    position:relative;

`